export default [
  {
    path: "/modules/report",
    redirect: "/modules/report/Event",
    name: "reportPageEvent",
    component: () => import("@/views/modules/report/Report.vue"),
    meta: {
      action: "ROLE_RELATORIO_CONSULTAR",
      resource: "ACL",
      pageTitle: "Relatórios",
      breadcrumb: [
        {
          text: "Eventos",
        },
      ],
    },
    children: [
      {
        path: "event",
        name: "event",
        component: () => import("@/views/modules/report/Report.vue"),
        meta: {
          pageTitle: "Relatórios",
          action: "ROLE_RELATORIO_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Módulo Eventos | Relatórios",
            },
          ],
        },
      },
    ],
  },
];
